import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import LandingHeader from '../../components/LandingPageComponents/LandingHeader/LandingHeader';
import 'typeface-inter';
import LandingFooter from '../../components/LandingPageComponents/LandingFooter/LandingFooter';
import ListenObserveActBanner from '../../components/LandingPageComponents/ListenObserveActBanner/ListenObserveActBanner';
import WhoIsBrandAstraForBanner from '../../components/LandingPageComponents/WhoIsBrandAstraForBanner/WhoIsBrandAstraForBanner';
import DataPointsBanner from '../../components/LandingPageComponents/DataPointsBanner/DataPointsBanner';
import BookaDemoBanner from '../../components/LandingPageComponents/BookaDemoBanner/BookaDemoBanner';
import FindAPlanCards from '../../components/LandingPageComponents/FindAPlanCards/FindAPlanCards';
import PlatformIntegrationTicker from '../../components/LandingPageComponents/PlatformintegrationTicker/PlatformIntegrationTicker';
import EmotionalEvolutionTabs from '../../components/LandingPageComponents/EmotionalEvolutionTabs/EmotionalEvolutionTabs';
import CustomerReviewsCarousal from '../../components/LandingPageComponents/CustomerReviewsCarousal/CustomerReviewsCarousal';
import BrandAstraBanner from '../../components/LandingPageComponents/BrandAstraBanner/BrandAstraBanner';
import ReviewComponent from '../../components/LandingPageComponents/ReviewComponent/ReviewComponent';
import HowMillionsofBrands from '../../components/LandingPageComponents/HowMillionsofBrands/HowMillionsofBrands';
import InsightsBanner from '../../components/LandingPageComponents/InsightsBanner/InsightsBanner';
import WhatDoesBrandAstraDo from '../../components/LandingPageComponents/WhatDoesBrandAstraDo/WhatDoesBrandAstraDo';
import ImpactAcrossTeams from '../../components/LandingPageComponents/ImpactAcrossTeams/ImpactAcrossTeams';
import SmartBrands from '../../components/LandingPageComponents/SmartBrands/SmartBrands';
import AllTheFeatures from '../../components/LandingPageComponents/AllTheFeatures/AllTheFeatures';
import HowItWorks from '../../components/LandingPageComponents/HowItWorks/HowItWorks';
import ImpactAcrossIndustries from '../../components/LandingPageComponents/ImpactAcrossIndustries/ImpactAcrossIndustries';
import FAQComponent from '../../components/LandingPageComponents/FAQComponent/FAQComponent';
import BookDemoPopup from './partials/BookDemoPopup';
import { Helmet } from 'react-helmet-async';

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
  overflow-y: scroll;
  background: radial-gradient(
    95.86% 126.4% at 0% 5.38%,
    rgba(226, 243, 187, 0.7) 0%,
    rgba(157, 200, 187, 0.7) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh; /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */

  @media only screen and (max-width: 768px) {
    max-height: ${(props) => (props.menuOpen ? '100vh' : 'unset')};
  }
`;
const HeaderWrapper = styled.div`
  // position: fixed;
  width: 100%;
  top: 0;
  z-index: 9;
  @media only screen and (max-width: 768px) {
    position: unset;
    display: flex;
    justify-content: center;
  }
`;

const LandingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Helmet>
        <title>BrandAstra | AI Marketing Intelligence & Research Tool</title>
        <meta name="description" content="An AI driven brand and social media listening tool for marketers and analysts, leveraging AI agents to accelerate how you monitor brand health, conduct competitive analysis, track social media trends, and analyze consumer sentiments and emotions across digital channels." />
        <meta name="keywords" content="BrandAstra, social listening, AI insights" />
        <link rel="canonical" href="https://brandastra.ai/" />
      </Helmet>
      <Wrapper menuOpen={menuOpen}>
        <HeaderWrapper>
          <LandingHeader
            setMenuOpen={(data) => {
              setMenuOpen(data);
            }}
            setPopupOpen={(data) => setIsOpen(data)}
          />
        </HeaderWrapper>
        <ReviewComponent />
        <HowMillionsofBrands setPopupOpen={(data) => setIsOpen(data)} />
        <InsightsBanner />
        <div id='what-do-we-do' style={{ width: '100%' }}>
          <WhatDoesBrandAstraDo />
        </div>
        <HowItWorks />
        <div id='impact' style={{ width: '100%' }}>
          <ImpactAcrossTeams />
        </div>
        <ImpactAcrossIndustries />
        <AllTheFeatures />
        <div id='faq' style={{ width: '100%' }}>
          <FAQComponent />
        </div>
        <SmartBrands setPopupOpen={(data) => setIsOpen(data)} />
        <BookDemoPopup isOpen={isOpen} setIsOpen={(data) => setIsOpen(data)} />
        {/* <BrandAstraBanner />
      <DataPointsBanner />
      <ListenObserveActBanner />
      <PlatformIntegrationTicker />
      <div id='what-do-we-do'>
        <EmotionalEvolutionTabs />
      </div>
      <div id='solutions'>
        <WhoIsBrandAstraForBanner />
      </div>
      <CustomerReviewsCarousal />
      <div id='pricing'>
        <FindAPlanCards />
      </div>
      <BookaDemoBanner /> */}
        <LandingFooter
          bgColor={'linear-gradient(99.96deg, #063257 0.95%, #006867 99.05%)'}
        />
      </Wrapper>
    </>
  );
};

export default LandingPage;
